module.exports = __webpack_public_path__ + "img/Image2.0ab3a5da.png";